import type { FaceMap, FacesDefault } from '@gymcloud/faces'

import type { LoggedSet } from '~/data/types'
import { fetchFaceMap } from '~/lib/face-maps'
import type { CopyState } from '~/lib/faces-copies'

/*
 * What the faces step settles, and what it asks with — `/specs/features/faces.spec.md`, Leaving
 * the app. Kept apart from the dialog and the hook so either can be read without the other.
 */

/** The copies the step made, one for each set, for the work that hands them over. */
export class HandedCopies {
  private readonly copies: ReadonlyMap<string, Blob | null>

  constructor(copies: ReadonlyMap<string, Blob | null>) {
    this.copies = copies
  }

  /** [setId]'s copy, or null where it could not be made. */
  of(setId: string): Blob | null {
    return this.copies.get(setId) ?? null
  }
}

/** The copy of the set the dialog is about, as it stands. */
export interface FacesShowing {
  readonly setId: string
  readonly copy: CopyState
}

/** What the three starting points say, which is also what they set every face to. */
export const START_LABELS: Record<FacesDefault, string> = {
  others: 'Everyone but me',
  all: 'Every face',
  none: 'Nobody’s',
}

/** A set's face map where it has one that describes its video; null where there is none. */
export async function mapOfSet(
  set: LoggedSet,
  url: (setId: string) => string,
): Promise<FaceMap | null> {
  return set.hasFaceMap === true ? fetchFaceMap(url(set.id), set.videoSize) : null
}

export interface Asking {
  readonly sets: readonly LoggedSet[]
  readonly verb: string
  readonly start: FacesDefault
  readonly work: (copies: HandedCopies) => Promise<boolean>
  readonly done: (went: boolean) => void
}
